import { Component, OnInit, OnDestroy, Input, Injectable  } from '@angular/core'
import { Router, Route, ActivatedRoute } from '@angular/router'
import { AuthService } from '../services/auth.service';
import { IUser } from '../models/account/user.model'
import { UserLogin } from '../models/account/user-login.model';
import { AlertService, MessageType, MessageSeverity } from '../services/alert.service';
import { Core } from '../shared/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { LoginResponse } from '../models/account/login-response.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

@Injectable()
export class LoginComponent implements OnInit, OnDestroy {
  currentUser: IUser;
  returnUrl: string;
  userLogin = new UserLogin();
  isLoading = false;

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute, private alertService: AlertService, private  msalService: MsalService) {
    
  }

  ngOnInit() {
   
  }

  ngOnDestroy() {

  }

  ngAfterViewInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['return'] || '/';
    if (this.msalService.instance.getActiveAccount() == null) {
      this.alertService.startLoadingMessage('', 'Attempting login...');
      this.authService.loginUser().subscribe((response: AuthenticationResult) => {
        this.msalService.instance.setActiveAccount(response.account);
        this.authService.getLoginEndpoint<LoginResponse>(response.account.localAccountId, response.account.name, this.msalService.instance.getActiveAccount().idTokenClaims.preferred_username).pipe(
          map(response => this.authService.processLoginResponse(response)))
          .subscribe(
            user => {
              this.alertService.stopLoadingMessage();
              this.alertService.showMessage('Login', `Welcome ${user.userName}`, MessageSeverity.information);
              this.router.navigate([this.returnUrl]);
            },
            error => {
              this.alertService.showMessage('Unable to login', Core.getHttpResponseMessage('', error), MessageSeverity.error);
              this.alertService.stopLoadingMessage();
            });

      });
    }



  }
}

